var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5625 3.0795C21.5625 2.43275 21.3058 1.81281 20.8483 1.35537C20.3917 0.898748 19.7717 0.641998 19.125 0.641998C15.4525 0.641998 6.5475 0.641998 2.875 0.641998C2.22825 0.641998 1.60832 0.898748 1.15169 1.35537C0.694254 1.81281 0.4375 2.43275 0.4375 3.0795V14.4959C0.4375 15.1427 0.694254 15.7626 1.15169 16.2192C1.60832 16.6767 2.22825 16.9334 2.875 16.9334H19.125C19.7717 16.9334 20.3917 16.6767 20.8483 16.2192C21.3058 15.7626 21.5625 15.1427 21.5625 14.4959V3.0795ZM6.59706 8.67681L2.31519 12.9042C1.98125 13.2341 2.00481 13.7484 2.368 14.0523C2.73037 14.3562 3.29669 14.3351 3.63063 14.0052L7.81175 9.87606L9.02726 11.0761C9.53507 11.5774 10.2501 11.8634 11 11.8634C11.7499 11.8634 12.4658 11.5774 12.9736 11.0761L14.1883 9.87606L18.3694 14.0052C18.7033 14.3351 19.2696 14.3562 19.6328 14.0523C19.9952 13.7484 20.0188 13.2341 19.6848 12.9042L15.4038 8.67681L19.6848 4.44856C20.0188 4.11869 19.9952 3.60437 19.6328 3.3005C19.2696 2.99744 18.7033 3.01856 18.3694 3.34844C18.3694 3.34844 13.9348 7.72781 11.6581 9.976C11.4883 10.1434 11.2502 10.2384 11 10.2384C10.7498 10.2384 10.5117 10.1434 10.3427 9.976L3.63063 3.34844C3.29669 3.01856 2.73037 2.99744 2.368 3.3005C2.00481 3.60437 1.98125 4.11869 2.31519 4.44856L6.59706 8.67681Z",
    fill: "#139ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.413d827137777e59e72b8f618d63959c.svg";
export { ForwardRef as ReactComponent };